module.exports = __webpack_public_path__ + "img/use-photo.36e4b006.png";